<template>
  <div class="login middle-box text-center loginscreen animated fadeInDown">
    <form v-on:submit.prevent="sendResetMail">
      <div class="m-t">
          <div class="login-panel">
              <div class="login-logo">
                  <img alt="image" class="" src="static/img/logo_nav.png" />
              </div>
              <div class="form-group text-left">
                {{$t('rePasswordLabel_1')}}<br>{{$t('rePasswordLabel_2')}}<br>
                {{$t('rePasswordLabel_3')}}
              </div>
                <div class="form-group text-left">
                    <label class="control-label">{{$t('placeholderMailString')}}</label>
                    <input type="text" v-model="email" class="form-control" :placeholder="$t('placeholderMailString')">
                </div>
                <div class="login-btnset">
                  <div class="col-sm-6 col-sm-offset-3 col-xs-12 col-xs-offset-0"><button type="submit" class="btn btn-success block m-b">{{ $t('senderTitle') }}</button></div>
                </div>
            </div>
            <div class="login-btnset">
                <!-- <button type="submit" class="btn btn-success block m-b">{{ $t('senderTitle') }}</button> -->
                <router-link :to="{ name: 'Login' }" class="btn btn-primary block m-b">{{$t('toLoginStr')}}</router-link>
            </div>
      </div>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'Reset',
  mixedins: [validationMixin],
  data () {
    return {
      email: ''
    }
  },
  validations: {
    email: { required }
  },
  methods: {
    sendResetMail: function () {
      let swal = this.$swal
      let $t = this.$t
      let $router = this.$router
      if (!this.$v.email.required) {
        swal({
          title: $t('noEmailStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else {
        this.$firebase.auth().sendPasswordResetEmail(this.email).then(function () {
          // Email sent.
          swal({
            // title: $t('compSendingPswdMailStr'),
            title: $t('popMessageStr12'),
            type: 'success',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 3000
          }).then((result) => {
            if (result.value) {
              // okが押下されたら
              $router.push({ name: 'Login' })
            } else {
              // cancelが押下されたら
              console.log('false')
            }
          })
        }).catch(function (error) {
          // An error happened.
          console.log(error.code)
          if (error.code === 'auth/invalid-email') {
            swal({
              title: $t('notEmailStr'),
              type: 'warning',
              animation: false,
              customClass: 'animated fadeInUp',
              // customClass: 'animated flipInX',
              width: '35rem',
              position: 'center',
              // toast: true,
              padding: '2rem',
              timer: 3000
            })
          } else if (error.code === 'auth/user-not-found') {
            swal({
              title: $t('missEmailStr'),
              type: 'warning',
              animation: false,
              customClass: 'animated fadeInUp',
              // customClass: 'animated flipInX',
              width: '35rem',
              position: 'center',
              // toast: true,
              padding: '2rem',
              timer: 3000
            })
          }
          return error
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Reset.vue